import { gql, useQuery } from '@apollo/client';
import { Button } from '@chakra-ui/button';
import { Text } from '@chakra-ui/layout';
import { BoxProps } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';

import { RecentlyAddedSponsors_RecentlyAddedSponsors } from './graphql-types/RecentlyAddedSponsors_RecentlyAddedSponsors';

import { SponsorsList } from './components/SponsorsList';

const RECENTLY_ADDED_SPONSORS = gql`
  query RecentlyAddedSponsors_RecentlyAddedSponsors {
    recentlyLaunchedSponsorsForCurrentUser {
      results {
        _id
        userOrganizationLink {
          _id
        }
        ...SponsorsList_OrganzationFragment
      }
    }
  }
  ${SponsorsList.organizationFragment}
`;

export const RecentlyAddedSponsors: React.FC<BoxProps> = ({ ...boxProps }) => {
  const { data, loading } =
    useQuery<RecentlyAddedSponsors_RecentlyAddedSponsors>(
      RECENTLY_ADDED_SPONSORS,
      {
        fetchPolicy: 'network-only',
        nextFetchPolicy: 'cache-first',
      }
    );

  if (
    loading ||
    !data?.recentlyLaunchedSponsorsForCurrentUser.results ||
    data.recentlyLaunchedSponsorsForCurrentUser.results.length < 1
  ) {
    return null;
  }

  const trimmedSponsorData =
    data.recentlyLaunchedSponsorsForCurrentUser.results.length > 3
      ? data.recentlyLaunchedSponsorsForCurrentUser.results.slice(0, 3)
      : data.recentlyLaunchedSponsorsForCurrentUser.results;

  return (
    <Card p="4" {...boxProps}>
      <Text color="gray.600" textStyle="compactStrong">
        RECENTLY ADDED SPONSORS
      </Text>
      <SponsorsList sponsors={trimmedSponsorData} />
      <NextLink href="/sponsors">
        <Button variant="outline" w="full" colorScheme="gray" mt="4">
          See All Sponsors
        </Button>
      </NextLink>
    </Card>
  );
};
